import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  fr: {
    // Navigation
    home: "Accueil",
    classes: "Cours",
    myBookings: "Mes réservations",
    dashboard: "Tableau de bord",
    marketing: "Marketing",
    logout: "Déconnexion",
    login: "Connexion",
    register: "S'inscrire",
    
    // Hero
    heroTitle: "Trouvez votre équilibre",
    heroSubtitle: "Réservez vos cours de Pilates en quelques clics",
    bookNow: "Réserver maintenant",
    learnMore: "En savoir plus",
    
    // Auth
    email: "Email",
    password: "Mot de passe",
    name: "Nom complet",
    phone: "Téléphone (optionnel)",
    signIn: "Se connecter",
    signUp: "Créer un compte",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    forgotPassword: "Mot de passe oublié ?",
    
    // Classes
    availableClasses: "Cours disponibles",
    spotsAvailable: "places disponibles",
    spotAvailable: "place disponible",
    full: "Complet",
    book: "Réserver",
    joinWaitlist: "Liste d'attente",
    onWaitlist: "En attente",
    instructor: "Instructeur",
    room: "Salle",
    capacity: "Capacité",
    
    // Bookings
    myReservations: "Mes réservations",
    upcomingClasses: "Cours à venir",
    waitlistStatus: "Liste d'attente",
    cancel: "Annuler",
    confirm: "Confirmer",
    checkIn: "Pointer",
    position: "Position",
    
    // Status
    reserved: "Réservé",
    confirmed: "Confirmé",
    present: "Présent",
    absent: "Absent",
    cancelled: "Annulé",
    
    // Coach Dashboard
    todaysClasses: "Cours du jour",
    participants: "Participants",
    noClasses: "Aucun cours aujourd'hui",
    totalClients: "Clients total",
    todayBookings: "Réservations aujourd'hui",
    manageClasses: "Gérer les cours",
    createClass: "Créer un cours",
    editClass: "Modifier",
    deleteClass: "Supprimer",
    
    // Class Form
    className: "Nom du cours",
    description: "Description",
    instructorName: "Nom de l'instructeur",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    save: "Enregistrer",
    
    // Marketing
    generateContent: "Générer du contenu",
    contentType: "Type de contenu",
    socialPost: "Post réseaux sociaux",
    sms: "SMS",
    emailContent: "Email",
    topic: "Sujet / Offre",
    tone: "Ton",
    generate: "Générer",
    generatedContent: "Contenu généré",
    copy: "Copier",
    copied: "Copié !",
    
    // Notifications
    notifications: "Notifications",
    spotAvailableTitle: "Place disponible !",
    noNotifications: "Aucune notification",
    markAsRead: "Marquer comme lu",
    
    // QR Check-in
    qrCheckin: "Check-in QR",
    scanToCheckin: "Scannez pour pointer votre présence",
    checkinSuccess: "Présence confirmée !",
    
    // Common
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    today: "Aujourd'hui",
    tomorrow: "Demain",
    thisWeek: "Cette semaine",
  },
  en: {
    // Navigation
    home: "Home",
    classes: "Classes",
    myBookings: "My Bookings",
    dashboard: "Dashboard",
    marketing: "Marketing",
    logout: "Logout",
    login: "Login",
    register: "Register",
    
    // Hero
    heroTitle: "Find your balance",
    heroSubtitle: "Book your Pilates classes in just a few clicks",
    bookNow: "Book now",
    learnMore: "Learn more",
    
    // Auth
    email: "Email",
    password: "Password",
    name: "Full name",
    phone: "Phone (optional)",
    signIn: "Sign in",
    signUp: "Create account",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    forgotPassword: "Forgot password?",
    
    // Classes
    availableClasses: "Available Classes",
    spotsAvailable: "spots available",
    spotAvailable: "spot available",
    full: "Full",
    book: "Book",
    joinWaitlist: "Join Waitlist",
    onWaitlist: "On Waitlist",
    instructor: "Instructor",
    room: "Room",
    capacity: "Capacity",
    
    // Bookings
    myReservations: "My Reservations",
    upcomingClasses: "Upcoming Classes",
    waitlistStatus: "Waitlist Status",
    cancel: "Cancel",
    confirm: "Confirm",
    checkIn: "Check-in",
    position: "Position",
    
    // Status
    reserved: "Reserved",
    confirmed: "Confirmed",
    present: "Present",
    absent: "Absent",
    cancelled: "Cancelled",
    
    // Coach Dashboard
    todaysClasses: "Today's Classes",
    participants: "Participants",
    noClasses: "No classes today",
    totalClients: "Total Clients",
    todayBookings: "Today's Bookings",
    manageClasses: "Manage Classes",
    createClass: "Create Class",
    editClass: "Edit",
    deleteClass: "Delete",
    
    // Class Form
    className: "Class Name",
    description: "Description",
    instructorName: "Instructor Name",
    startTime: "Start Time",
    endTime: "End Time",
    save: "Save",
    
    // Marketing
    generateContent: "Generate Content",
    contentType: "Content Type",
    socialPost: "Social Media Post",
    sms: "SMS",
    emailContent: "Email",
    topic: "Topic / Offer",
    tone: "Tone",
    generate: "Generate",
    generatedContent: "Generated Content",
    copy: "Copy",
    copied: "Copied!",
    
    // Notifications
    notifications: "Notifications",
    spotAvailableTitle: "Spot Available!",
    noNotifications: "No notifications",
    markAsRead: "Mark as read",
    
    // QR Check-in
    qrCheckin: "QR Check-in",
    scanToCheckin: "Scan to check in",
    checkinSuccess: "Check-in successful!",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    close: "Close",
    back: "Back",
    next: "Next",
    today: "Today",
    tomorrow: "Tomorrow",
    thisWeek: "This week",
  },
  es: {
    // Navigation
    home: "Inicio",
    classes: "Clases",
    myBookings: "Mis reservas",
    dashboard: "Panel",
    marketing: "Marketing",
    logout: "Cerrar sesión",
    login: "Iniciar sesión",
    register: "Registrarse",
    
    // Hero
    heroTitle: "Encuentra tu equilibrio",
    heroSubtitle: "Reserva tus clases de Pilates en pocos clics",
    bookNow: "Reservar ahora",
    learnMore: "Saber más",
    
    // Auth
    email: "Email",
    password: "Contraseña",
    name: "Nombre completo",
    phone: "Teléfono (opcional)",
    signIn: "Iniciar sesión",
    signUp: "Crear cuenta",
    noAccount: "¿No tienes cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    forgotPassword: "¿Olvidaste tu contraseña?",
    
    // Classes
    availableClasses: "Clases disponibles",
    spotsAvailable: "plazas disponibles",
    spotAvailable: "plaza disponible",
    full: "Completo",
    book: "Reservar",
    joinWaitlist: "Lista de espera",
    onWaitlist: "En espera",
    instructor: "Instructor",
    room: "Sala",
    capacity: "Capacidad",
    
    // Bookings
    myReservations: "Mis reservas",
    upcomingClasses: "Próximas clases",
    waitlistStatus: "Lista de espera",
    cancel: "Cancelar",
    confirm: "Confirmar",
    checkIn: "Registrar",
    position: "Posición",
    
    // Status
    reserved: "Reservado",
    confirmed: "Confirmado",
    present: "Presente",
    absent: "Ausente",
    cancelled: "Cancelado",
    
    // Coach Dashboard
    todaysClasses: "Clases de hoy",
    participants: "Participantes",
    noClasses: "No hay clases hoy",
    totalClients: "Total de clientes",
    todayBookings: "Reservas de hoy",
    manageClasses: "Gestionar clases",
    createClass: "Crear clase",
    editClass: "Editar",
    deleteClass: "Eliminar",
    
    // Class Form
    className: "Nombre de la clase",
    description: "Descripción",
    instructorName: "Nombre del instructor",
    startTime: "Hora de inicio",
    endTime: "Hora de fin",
    save: "Guardar",
    
    // Marketing
    generateContent: "Generar contenido",
    contentType: "Tipo de contenido",
    socialPost: "Post redes sociales",
    sms: "SMS",
    emailContent: "Email",
    topic: "Tema / Oferta",
    tone: "Tono",
    generate: "Generar",
    generatedContent: "Contenido generado",
    copy: "Copiar",
    copied: "¡Copiado!",
    
    // Notifications
    notifications: "Notificaciones",
    spotAvailableTitle: "¡Plaza disponible!",
    noNotifications: "Sin notificaciones",
    markAsRead: "Marcar como leído",
    
    // QR Check-in
    qrCheckin: "Check-in QR",
    scanToCheckin: "Escanea para registrar tu asistencia",
    checkinSuccess: "¡Registro exitoso!",
    
    // Common
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    close: "Cerrar",
    back: "Volver",
    next: "Siguiente",
    today: "Hoy",
    tomorrow: "Mañana",
    thisWeek: "Esta semana",
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('pilates-language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('pilates-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['fr']?.[key] || key;
  };

  const value = {
    language,
    setLanguage,
    t,
    availableLanguages: ['fr', 'en', 'es'],
    languageNames: { fr: 'Français', en: 'English', es: 'Español' }
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
